import MainSection from "./MainSection.js";
import Story from "./Story.js";
import Collection from "./Collection.js";
import Community from "./Community.js";
import Loadmap from "./Loadmap.js";
import Whitepaper from "./Whitepaper";
import Precopy from "./Precopy.js";
import Copy from "./Copy.js";

function Home() {
  document.title = "Lion Travelers Home";
  return (
    <div className="Home">
      <MainSection />
      <Story />
      <Collection />
      <Community />
      <Loadmap />
      <Whitepaper />
      <Precopy />
      <Copy />
    </div>
  );
}

export default Home;
